import alt from "../alt";

class BallotActions {
  constructor() {
    this.generateActions(
      "fetchStats",
      "fetchVotes",
      "fetchTabulations",
      "tabulate"
    );
  }
}

export default alt.createActions(BallotActions);



// WEBPACK FOOTER //
// ./src/app/actions/BallotActions.js